export default __webpack_public_path__ + "static/media/blocked.74d901a2.png";